import { YoutubeAnalyticsAudiencePayload } from '@anytag/graphql';
import { ChartsContainer } from '@anytag/shared-atoms';
import { AgeBreakdownChart, AreaBreakdownChart, GenderBreakdownChart } from '@anytag/shared-molecules';
import { AnalyticsAudienceWrapper } from '../../../shared';
import { AnalyticsSelectedAccountInfo } from '../../../types';

export interface AnalyticsYoutubeDashboardAudienceTemplateProps {
  loading?: boolean;
  className?: string;
  data?: Partial<YoutubeAnalyticsAudiencePayload> | null;
  accountAvatar?: AnalyticsSelectedAccountInfo['avatar'];
}

export const AnalyticsYoutubeDashboardAudienceTemplate = ({
  data,
  loading,
  className,
  accountAvatar
}: AnalyticsYoutubeDashboardAudienceTemplateProps) => (
  <AnalyticsAudienceWrapper loading={loading} data={data} className={className}>
    {({ data: { ageRate, genderRate, regionRate, countryRate } }) => (
      <ChartsContainer
        css={{ height: '385px' }}
        elements={[
          <GenderBreakdownChart {...genderRate} />,
          <AgeBreakdownChart {...ageRate} />,
          <AreaBreakdownChart
            avatar={accountAvatar}
            followerRegionRate={regionRate}
            followerCountryRate={countryRate?.map(({ countryId, rate }) => ({ id: countryId, rate }))}
            hasCountriesRates
          />
        ]}
      />
    )}
  </AnalyticsAudienceWrapper>
);
